/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 14c4.244 0 6.888 2.775 6.997 6.745L16 21v1h-2v-1c0-3.036-1.809-5-5-5-3.107 0-4.904 1.862-4.996 4.763L4 21v1H2v-1c0-4.105 2.666-7 7-7zm9.496 1.132c2.118 1.21 3.41 3.272 3.499 5.607L22 21v1h-2v-1c0-1.634-.832-3.088-2.285-4.005l-.211-.127zM16 4a5 5 0 0 1 0 10 4.94 4.94 0 0 1-2.25-.539l-.255-.14 1.011-1.725c.45.264.96.404 1.494.404a3 3 0 0 0 .177-5.995L15.999 6zM9 2a5 5 0 1 1 0 10A5 5 0 0 1 9 2zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgContactGroup as ContactGroup };
